export const HOST = "http://127.0.0.1"
export const PORT = "38088"
export const PFX = "D:\\"